import NavBar from "./NavBar";

function Home(props) {
    return (
        <div className="main-layout">
            <NavBar {...props}/>
        </div>
    );
}

export default Home;
